import Header from "../components/Header";
import Hero from "../components/Hero";
import SolarPanels from "../components/SolarPanels";
import About from "../components/About";
import Partners from "../components/Partners";
import Reviews from "../components/Reviews";
import SolarInfo from "../components/SolarInfo";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";



const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <SolarPanels />
      <About />
      <SolarInfo />
      <Partners />
      <Reviews />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Index;
